const DEFAULT_STYLE = {
    weight: 3,
    color: '#000000',
    opacity: 1,
    fillOpacity: 1,
    dashArray: null
};

const DASH_ARRAY_STYLE = "5 10";

/* une regexp qui accepte uniquement les chaines de caratères qui commencent comme suit (insensible à la casse) :
    - gpe_lignes.
*/
const regexpShouldBeDashArray = /^(gpe_lignes)\./i;

class GeojsonStyleHelper {
    static regexpShouldBeDashArray (id) { return id.match(regexpShouldBeDashArray); };
    static get defaultStyle () { return DEFAULT_STYLE; };
    static get dashArrayStyle () { return DASH_ARRAY_STYLE; };

    constructor (parameters = {}) {
        this.weight = parameters.weight ? parameters.weight : DEFAULT_STYLE.weight;
        this.color = parameters.color ? parameters.color : DEFAULT_STYLE.color;
        this.opacity = parameters.opacity ? parameters.opacity : DEFAULT_STYLE.opacity;
        this.fillOpacity = parameters.fillOpacity ? parameters.fillOpacity : DEFAULT_STYLE.fillOpacity;
        this.dashArray = parameters.dashArray ? parameters.dashArray : DEFAULT_STYLE.dashArray;
    }
}

export { GeojsonStyleHelper }